
const TERMINAL_SHUT_DOWN = 40
const PERIOD_CLOSING = 50
const START_OF_TERMINAL = 80
const PRINTER_NOT_AVAILABLE = 150
const ACCOUNTING_TICKET_CANCELLATIONS = 190
const VERSION_OF_THE_SOFTWARE = 250
const ABANDONMENT_OF_A_NON_VALIDATED_SALE_TRANSACTION = 320

export default {
  TERMINAL_SHUT_DOWN,
  PERIOD_CLOSING,
  START_OF_TERMINAL,
  PRINTER_NOT_AVAILABLE,
  ACCOUNTING_TICKET_CANCELLATIONS,
  VERSION_OF_THE_SOFTWARE,
  ABANDONMENT_OF_A_NON_VALIDATED_SALE_TRANSACTION,
}
